import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function userInfoReducer(state = initialState, action) {
  switch (action.type) {
    case types.LOADED_USER_INFO_SUCCESS:
      return action.userInfo;

    case types.SET_USER_ROLE:
      return {
        ...state,
        role_id: action.role ?? state.role_id
      };

    default:
      return state;
  }
} 
